import "./FormikInput.scss";
import { ErrorMessage } from "formik";
import { TextFieldVariants } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CustomInput from "components/CustomInput/CustomInput";

interface FormInputProps {
  label: string;
  name: string;
  id: string;
  touched?: boolean;
  error?: string;
  variant: TextFieldVariants;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  value?: string;
}
const FormikInput = ({
  label,
  name,
  id,
  variant,
  touched,
  error,
  onChange,
  onBlur,
  value
}: FormInputProps) => {
  return (
    <div className="form-input">
      <CustomInput
        name={name}
        id={id}
        label={label}
        variant={variant}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={touched && error ? "error-field" : ""}
      />
      <ErrorMessage
        name={name}
        render={(msg) => (
          <div className="error-message">
            <InfoOutlinedIcon />
            {msg}
          </div>
        )}
      />
    </div>
  );
};

export default FormikInput;
